import InitializeLayout from '@js/layout';

import RideManager from '@js/managers/rideManager';

InitializeLayout();

RideManager.initialize();
